import { KpopStudyPageTemplate } from "@/components/KpopStudyPageTemplate";

const StudyWithAespa = () => {
  return (
    <KpopStudyPageTemplate
      groupName="aespa"
      groupNameDisplay="aespa"
      fandomName="MYs"
      seoTitle="Study With aespa - MY Study Rooms"
      seoDescription="Study with aespa fans worldwide. Join MYs in virtual study rooms with aespa playlists and futuristic themed spaces."
      seoKeywords="study with aespa, aespa study room, my study, kpop study room"
      canonicalUrl="/study-with-aespa/"
      heroDescription="Join MYs worldwide who study with aespa's futuristic and innovative energy. Level up your productivity."
      aboutContent={
        <>
          <p>
            <a href="https://www.smtown.com/artist/detail/43" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">aespa</a> is a groundbreaking South Korean girl group formed by <a href="https://www.smentertainment.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">SM Entertainment</a>. The group consists of Karina, Giselle, Winter, and Ningning.
          </p>
          <p>
            MYs find inspiration in aespa's cutting-edge concepts. Follow them on <a href="https://www.instagram.com/aespa_official/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Instagram</a>, <a href="https://twitter.com/aespa_official" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">X (Twitter)</a>, and <a href="https://www.youtube.com/@aespa" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">YouTube</a>.
          </p>
        </>
      }
      riseOfContent={
        <p>
          aespa fans have created spaces to combine their passion with productive study sessions, playing <a href="https://open.spotify.com/artist/6YVMFz59CuY7ngCxTxjpxE" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">aespa's music on Spotify</a> in the background.
        </p>
      }
      featureCards={[
        { title: "aespa Study Playlists", desc: "Level up your study sessions with curated aespa playlists." },
        { title: "Connect with MYs", desc: "Join study rooms with fellow MYs from around the world." },
        { title: "Futuristic Study Spaces", desc: "Experience aespa-themed study rooms with futuristic aesthetics." },
        { title: "Next Level Sessions", desc: "Access next-level study sessions 24/7." },
      ]}
      whyPerfectDescription="CSW is more than just a study platform; it's a place where fans of aespa can come together, stay motivated, and achieve their goals."
      communityDescription1="CSW – Chill Study Work is more than just a study platform; it's a place to connect with like-minded individuals."
      communityDescription2="Discover how studying with your favorite idols can transform your academic journey."
      socialLinks={[
        { name: "Official Website", url: "https://www.smtown.com/artist/detail/43" },
        { name: "YouTube", url: "https://www.youtube.com/@aespa" },
        { name: "Instagram", url: "https://www.instagram.com/aespa_official/" },
        { name: "X (Twitter)", url: "https://twitter.com/aespa_official" },
        { name: "Spotify", url: "https://open.spotify.com/artist/6YVMFz59CuY7ngCxTxjpxE" },
      ]}
      youtubeVideos={[
        { id: "WPdWvnAAurg", title: "aespa - Supernova M/V" },
        { id: "4TWR90KJl84", title: "aespa - Next Level M/V" },
        { id: "WPdWvnAAurg", title: "aespa - Savage M/V" },
        { id: "ZeerrnuLi5E", title: "aespa - Black Mamba M/V" },
        { id: "Os_heh8vPfs", title: "aespa - Girls M/V" },
        { id: "phuiiNCxRMg", title: "aespa - Spicy M/V" },
      ]}
      youtubeChannelUrl="https://www.youtube.com/@aespa"
      youtubeChannelName="aespa"
    />
  );
};

export default StudyWithAespa;
